<template>
  <div ref="root">
    <!-- <router-view class="active-view">
      <object-on-demand />
    </router-view> -->
    <!-- dObject.model:{{ dObject.model }} model:{{ model }} -->
    {{ label }}
    <v-form-card
      v-if="schema"
      :dObject="dObject"
      v-bind="schema['v-bind']"
      :inTable="false"
      ref="form"
      :panels="true"
      :key="formKey"
      :noCache="noCache"
      :noEditForm="true"
      :hasParent="hasParent"
    ></v-form-card>
    <!-- <v-form-component
      v-if="schema"
      ref="formComponent"
      :key="formKey"
      :model="model"
      :vModel="model"
      :schema="schema"
      :noEditForm="true"
      :noCache="true"
      :noMainTabs="false"
      :data_object="dataObject"
    /> -->
  </div>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "ObjectOnDemand",

  components: {
    VFormComponent: () => import("../components/FormComponent.vue"),
    VFormCard: () => import("../components/FormCard.vue")
  },

  props: {
    vModel: String,
    parModel: [Object, Array, String],
    parentModel: [Object, Array, String],
    formModel: [Object, Array, String],
    parObject: Object,
    parentObject: Object,
    parentSchema: Object,
    label: String,

    k: String,
    parentKey: String,
    topParentProperty: String
  },

  data() {
    return {
      dataObject: null,
      objectName: "",
      formKey: 0,
      model: null,
      schema: null,
      defaultValues: null,
      dObject: null,
      noCache: true,
      parentComponent: null
    };
  },

  mounted() {
    this.parentComponent = fun.getParentByProperty(this, this.topParentProperty);
    this.dObject = {
      model: null,
      schema: null
    };
    this.getDataObject();
    var that = this;
    this.$root.$on("parentSaving", a => {
      that.save();
    });
    window.addEventListener("message", this.handleParentMessage.bind(this));
  },

  beforeDestroy() {
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  },

  methods: {
    handleParentMessage(event) {
      console.log("message", event.data?.payload?.message);
      console.log("type", event.data?.type);
      // this.$root.hideAppBar = true;
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === "PARENT_SAVING") {
        this.save();
      }
      if (event.data?.type === "DEFAULT_VALUES") {
        this.addDefaultValues(event.data?.payload?.message);
      }
    },
    addDefaultValues(data) {
      try {
        data = JSON.parse(data);
      } catch (error) {
        //
      }
      // this.defaultValues = JSON.parse(data);
      // this.model = {};
      // this.model[this.objectName] = this.defaultValues;
      this.dObject.model = data;
      this.formKey = !this.formKey;
      // console.log(this.model);
    },
    save() {
      var that = this;

      var data = {
        metadata: {
          object_name: this.objectName
        },
        // model: this.model[this.objectName]
        model: this.dObject.model
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(function(response) {
          //
        });
    },
    getDataObject() {
      var that = this;
      // const params = this.$router.currentRoute.params;
      // this.id = params.objectId;
      this.id = this.vModel;
      this.objectName = this.k;
      if (Object.keys(this.id).length === 0) {
        return;
      }

      // if (params.objectId == "[object Object]") {
      //   id = fun.guid();
      // } else {

      // }
      // this.objectName = params.objectName;
      const objectName =
        this.objectName == "international_shipment" ? "v_international_shipment_with_jobs" : this.objectName;
      const data_object = {
        object_name: objectName,
        qry: { _id: this.id }
      };

      axios
        .post(this.serverURL + "/get_data", data_object, {
          withCredentials: true
        })
        .then(response => {
          if (response.data && response.data.model) {
            if (!that.defaultValues) {
              // that.model = {};
              // that.model[this.objectName] = response.data.model[0] || {
              //   _id: this.id
              // };
              that.model = response.data.model[0] || {
                _id: this.id
              };
            }

            this.schema = response.data.schema;
            // this.schema[this.objectName] = response.data.schema;
            // this.dataObject = {
            //   schema: this.schema,
            //   objectName: this.objectName
            // };
            this.dObject = {
              schema: this.schema,
              model: this.model,
              topObject: objectName
            };
            if (that.parentComponent?.onDemandComponentUpdateSchema) {
              that.schema = fun.mergeMissing(that.schema, that.parentComponent.onDemandComponentUpdateSchema);
            }

            if (that.parentComponent?.onDemandComponentDefaultValuesChanged || Object.keys(that.model).length == 1) {
              const data = that.parentComponent?.onDemandComponentDefaultValues;
              this.addDefaultValues(data);
            }
            // this.detachFromParent();
          }
        });
    },

    emitClick(r) {
      this.$root.$emit("arrayElementClick", { item: r, obj: this });
    }
  },
  watch: {
    "parentComponent.saving": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.save();
        }
      }
    },
    "parentComponent.onDemandComponentDefaultValuesChanged": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.addDefaultValues(this.parentComponent.onDemandComponentDefaultValues);
        }
      }
    }
  }
};
</script>

<style scoped>
/* optional styling */
</style>
